import styled from "styled-components"
import { Link } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

import { LinkButton } from "./LinkButton"

export const PromoLandingSection = styled.section`
  background-color: #f5f5f5;

  @media (min-width: 768px) {
    background-color: #fff;
    min-height: calc(100vh - 4rem);
  }

  @media (max-width: 767px) {
    padding: 1rem 1rem 0;
  }
`

export const PromoLandingCard = styled.div`
  margin: 0 auto;
  max-width: 100%;
  background-color: #fff;

  @media (min-width: 768px) {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    min-height: calc(100vh - 4rem);
  }

  @media (max-width: 767px) {
    border-radius: 2px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
    overflow: hidden;
  }
`

export const PromoLandingMedia = styled.div`
  overflow: hidden;
  line-height: 0;

  @media (min-width: 768px) {
    flex: 1 1 50%;
    min-height: 24rem;
  }
`

export const PromoLandingImage = styled.img`
  display: block;
  width: 100%;
  height: auto;
  object-fit: cover;
  object-position: center top;

  @media (min-width: 768px) {
    height: 100%;
    min-height: 100%;
    width: 100%;
  }
`

export const PromoLandingContent = styled.div`
  padding: 1.5rem 1.25rem 2rem;
  text-align: left;
  align-items: flex-start;

  @media (min-width: 768px) {
    display: flex;
    flex: 1 1 50%;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    padding: 3rem clamp(2rem, 5vw, 5rem);
  }

  @media (max-width: 767px) {
    padding: 1.25rem 1rem 1.5rem;
  }
`

export const PromoLandingTitle = styled.h1`
  color: #262626;
  font-family: "TeleNeoWeb-ExtraBold", sans-serif;
  font-size: 1.75rem;
  font-weight: 800;
  letter-spacing: -0.04em;
  line-height: 1.15;
  margin: 0 0 0.75rem;
  text-align: left;

  @media (min-width: 768px) {
    font-size: clamp(2rem, 3.2vw, 2.75rem);
    line-height: 1.12;
    max-width: 100%;
    width: 100%;
  }

  @media (max-width: 767px) {
    margin-bottom: 0.75rem;
  }
`

export const PromoLandingSubtitle = styled.p`
  color: var(--general-text-primary, #141414);
  font-family: var(--font-family-body, "SF Pro"), -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  font-size: var(--font-size-12, 12px);
  font-weight: 400;
  line-height: 1.5;
  margin: 0 0 1.25rem;
  max-width: 28rem;

  @media (min-width: 768px) {
    max-width: 100%;
  }

  @media (max-width: 767px) {
    margin-bottom: 1.25rem;
  }
`

export const PromoLandingCta = styled(LinkButton)`
  align-self: flex-start;
  border-radius: 4px !important;
  display: inline-block;
  margin-bottom: 1.5rem !important;
  margin-top: 0;
  min-width: 0;
  padding: 0.5rem 1.25rem !important;
  width: auto !important;
  max-width: 100%;

  @media (max-width: 767px) {
    margin-bottom: 1rem !important;
  }
`

export const PromoLandingLinks = styled.div`
  color: var(--general-text-primary, #141414);
  font-family: var(--font-family-body, "SF Pro"), -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  font-size: var(--font-size-12, 12px);
  font-weight: 400;
  line-height: 1.5;
  max-width: 28rem;
  width: 100%;

  p {
    font-size: inherit;
    line-height: inherit;
    margin: 0;
  }

  a {
    color: var(--general-text-brand, #e20074);
    font-size: inherit;
    font-weight: 400;
    text-decoration: underline;
  }

  @media (min-width: 768px) {
    max-width: 100%;
  }
`

export const QuickActionList = styled.ul`
  border-top: 1px solid #e6e6e6;
  list-style: none;
  margin: 0 0 1.25rem;
  padding: 0;
  width: 100%;

  @media (min-width: 768px) {
    margin-bottom: 0.75rem;
  }

  @media (max-width: 767px) {
    margin-bottom: 0;
  }
`

export const QuickActionItem = styled.li`
  border-bottom: 1px solid #e6e6e6;
`

export const QuickActionLabel = styled.span`
  color: var(--general-text-primary, #141414);
  font-size: 1rem;
  font-weight: 700;
`

export const QuickActionSublabel = styled.span`
  color: var(--general-text-secondary, #5a5a5a);
  font-size: var(--font-size-12, 12px);
  margin-top: 0.25rem;
`

export const QuickActionText = styled.span`
  display: flex;
  flex-direction: column;
`

export const QuickActionChevron = styled(FontAwesomeIcon)`
  color: var(--general-text-secondary, #5a5a5a);
  flex-shrink: 0;
`

export const QuickActionLink = styled.a`
  align-items: center;
  color: inherit;
  display: flex;
  gap: 0.75rem;
  justify-content: space-between;
  padding: 1rem 0;
  text-decoration: none;
  width: 100%;

  &:link,
  &:visited,
  &:hover,
  &:focus,
  &:active {
    color: inherit;
    text-decoration: none;
  }

  &:hover ${QuickActionLabel},
  &:focus ${QuickActionLabel} {
    text-decoration: underline;
  }

  &:focus-visible {
    outline: 2px solid var(--general-text-brand, #e20074);
    outline-offset: 2px;
  }
`

export const FaqLine = styled.p`
  color: inherit;
  font: inherit;

  @media (min-width: 768px) {
    margin-top: 0;
  }

  @media (max-width: 767px) {
    margin-top: 1.25rem;
  }
`

export const FaqPrompt = styled.span`
  color: inherit;
  font: inherit;
`

export const FaqLink = styled(Link)`
  color: var(--general-text-brand, #e20074);
  font-family: inherit;
  font-size: inherit;
  font-weight: 700;
  text-decoration: underline;

  &:hover,
  &:focus {
    color: var(--general-text-brand, #e20074);
  }
`

export const LearnMoreLine = styled.p`
  margin-bottom: 0;
`
